import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Globals } from '../../globals';
import { AutoLoginData } from './AutoLoginData.interface';

@Injectable({
  providedIn: 'root',
})
export class SemsaAutoLoginService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);

  private get url() {
    return `${this.globals.apiRoot}/semsaWizardAutologin`;
  }

  allowAutoLoginAndSendMail(email: string, networkDeviceId: number) {
    return this.http.post(this.url, { email, networkDeviceId });
  }

  allowAutoLoginAndGetData(): Promise<AutoLoginData | undefined> {
    return this.http
      .post<AutoLoginData>(this.url + '/data', undefined)
      .toPromise();
  }
}
